<template>
  <gj-tree-manager
      ref="treeManager"
      title="关键词"
      :subTitle="subTitle"
      :loading="loading"
      :data="data"
      node-key="id"
      edit-icon-size="14px"
      delete-icon-size="14px"
      tree-height="auto"
      :add-icon="$permission('keywordRank:edit')"
      :edit-icon="$permission('keywordRank:edit')"
      :delete-icon="$permission('keywordRank:edit')"
      @add="add"
      @edit="edit($event)"
      @delete="deleteItem($event)"
      @node-click="select">
    <template #filter-group>
      <div style="margin-bottom: 10px;">
        <gj-select
            v-model="filter.countryCode"
            width="214px"
            :options="countryOption"
            placeholder="请选择国家"
            @input="$gjNoticeQuery">
          <template v-slot:default="{option}">
            <el-row type="flex" align="middle">
              <gj-icon :iconfont="option.icon" class="country-icon"></gj-icon>
              <span>{{option.text}}</span>
            </el-row>
          </template>
        </gj-select>
      </div>
      <div>
        <gj-select-input
            v-model="filter.keyword"
            :options="[
              {id: 'name', text: '名称'},
              {id: 'asin', text: 'ASIN'},
            ]"
            :width="['80px', '135px']"
            @input="$gjNoticeQuery"
        ></gj-select-input>
      </div>
    </template>
    <template v-slot:node="{data}">
      <el-row type="flex"
              align="middle"
              style="padding-left: 10px;">
        <gj-icon :iconfont="data.icon" class="country-icon--big"></gj-icon>
        <div>
          <div class="keyword--name">
            <gj-text style="width: 120px;">{{data.name}}</gj-text>
          </div>
          <div class="keyword--asin">
            <gj-text style="max-width: 120px;padding-right: 3px">{{data.asin}}</gj-text>
            <gj-tooltip v-if="data.parentAsin">
              <span class="text-icon text-father">父</span>
              <template #content>父ASIN</template>
            </gj-tooltip>
            <gj-tooltip v-if="!data.parentAsin">
              <span class="text-icon text-son">子</span>
              <template #content>子ASIN</template>
            </gj-tooltip>
            <gj-tooltip v-if="data.ownerAsin">
              <span class="text-icon text-since">自</span>
              <template #content>已授权店铺中的ASIN</template>
            </gj-tooltip>
          </div>
        </div>
      </el-row>
    </template>
  </gj-tree-manager>
</template>

<script>
  import { OpEnum } from "@/utils/options";
  import AppAsinMonitorOpModal from "../modal/op/asin-monitor-op-modal";
  import { deleteAdKeywordRank, keywordRank } from "@/api/ad";
  import { queryMixin } from "@/minxins";
  import { transformToMap } from "@/utils/common";
  import { KeywordRankEnum } from "modules/common/ad/rank/keyword-rank/enum";
  import { mapGetters } from "vuex";
  export default {
    name: "app-ad-keyword-tree",
    mixins: [queryMixin],
    data() {
      return {
        loading: false,
        data: [],
        curNodeId: null,
        filter: {
          countryCode: null,
          keyword: {
            key: 'name',
            value: null
          }
        },
        KeywordRankEnum: KeywordRankEnum
      }
    },
    computed: {
      ...mapGetters(['tenantPay','userInfo']),
      countryOption() {
        return KeywordRankEnum.countryOption.map(item => ({
          id: item.id,
          text: item.text.split('-')[0],
          icon: item.icon
        }));
      },
      subTitle(){
        let str='';
        if(this.tenantPay&&this.tenantPay.payStatus&&this.tenantPay.payStatus.code==='NOT_PAID'&&this.userInfo&&this.userInfo.freeOrder === true){
          str='(可免费添加50个)'
        }
        return str
      }
    },
    methods: {
      $gjQuery() {
        // 构造查询参数
        const params = {
          countryCode: this.filter.countryCode
        };
        params[this.filter.keyword.key] = this.filter.keyword.value;
        // 查询
        this.loading = true;
        keywordRank.getAdsRankGroupList(params)
          .then(({ data }) => {
            const obj = transformToMap(KeywordRankEnum.countryOption);
            data.forEach(item => {
              if (obj[item.countryCode]) {
                item.icon = obj[item.countryCode].icon;
              }
            });
            this.data = data;
            if (data.length > 0) {
              // 默认选择第一个监控
              this.$nextTick(() => {
                this.$refs.treeManager.$refs.tree.setCurrentKey(data[0].id);
              });
              this.curNodeId = data[0].id;
              this.$emit('select', {
                locationGroupId: data[0].id,
                countryCode: data[0].countryCode,
              });
            } else {
              // 无监控，清空监控详情数据
              this.curNodeId = null;
              this.$emit('clear');
            }
          })
          .complete(() => this.loading = false);
      },
      select(data, node) {
          this.curNodeId = data.id;
          node.isCurrent = true;
          this.$emit('select', {
            locationGroupId: data.id,
            countryCode: data.countryCode,
          });
      },
      add() {
        this.$gjCreate(AppAsinMonitorOpModal, {
          props: {
            opType: OpEnum.type.ADD
          },
          on: {
            created: () => {
              this.$gjResetPage();
            }
          }
        });
      },
      edit(item) {
        this.$gjCreate(AppAsinMonitorOpModal, {
          props: {
            opType: OpEnum.type.UPDATE,
            keyword: item
          },
          on: {
            updated: () => {
              let item = this.data.find(e => e.id === this.curNodeId)
              item && this.$emit('select', {
                locationGroupId: item.id,
                countryCode: item.countryCode,
              });
            }
          }
        });
      },
      deleteItem(item) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '删除确认',
            content: `确定要删除[${item.name}]吗？一旦删除不可恢复，请谨慎操作！`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              deleteAdKeywordRank(item.id)
                .then(() => {
                  this.$gjMessage.success('删除成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .country-icon {
    margin-right: 8px;
    font-size: 18px;
  }
  .country-icon--big {
    margin-right: 10px;
    font-size: 40px;
    line-height: normal;
  }
  /deep/ .el-tree-node {
    margin: 4px 0;
  }
  /deep/ .el-tree-node__content {
    position: relative;
    height: auto;
    padding: 2px 0;
  }
  /deep/ .el-tree-node__expand-icon.is-leaf {
    display: none;
  }
  /deep/ .gj-tree-child {
    top: 17px;
  }
  .keyword--name {
    font-size: 12px;
    color: #333;
    font-weight: bold;
  }
  .keyword--asin {
    font-size: 12px;
    color: #666;
    /deep/.gj-tooltip {
      margin-right: 6px;
    }
    .text-icon {
      width: 17px;
      height: 17px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
      transform: scale(.9);
     font-size: 12px;
      &.text-father {
        color: #ED6A0C;
        background: #FFF5ED;
        border: 1px solid #ED6A0C;
      }
      &.text-son {
        color: #1F6EEF;
        background: #EDF7FF;
        border: 1px solid #4994FC;
      }
      &.text-since {
        color: #8A3FD4;
        background: #F7F2FC;
        border: 1px solid #A973DF;
      }
    }
  }
  .keyword--name {
    margin-bottom: 4px;
  }
  .keyword--name,
  .keyword--asin {
    line-height: normal;
  }
  .is-current .keyword--name{
    color: #1F6EEF;
  }
  /deep/.tree-header-title{
    color: #333;
  }
</style>
